<template>
  <v-dialog
    id="nav-help-dialog"
    v-model="isOpen"
    persistent
    width="300px"
    theme="light"
  >
    <template #activator="{ props }">
      <v-btn
        v-show="isLoggedIn"
        id="nav-help-button"
        size="small"
        v-bind="props"
        icon="fas fa-question-circle"
      />
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        About
      </v-card-title>

      <v-card-text v-html="aboutText" />

      <HelpDialogTooltip
        :is-logged-in="isLoggedIn"
        :is-admin="isAdmin"
        :token-string="tokenString"
      />

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="isOpen = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HelpDialogTooltip from "./HelpDialogTooltip.vue";
export default defineComponent({
  name: "HelpDialog",
  components: {
    HelpDialogTooltip,
  },
  props: {
    isLoggedIn: Boolean,
    isAdmin: Boolean,
    tokenString: String,
    aboutText: String,
  },
  data() {
    return {
      isOpen: false,
    };
  },
});
</script>

<style scoped>
#nav-help-button {
  color: white;
}

#nav-help-dialog {
  width: 300px;
}
</style>
